import { render } from "./PosSales.vue?vue&type=template&id=63449928&scoped=true"
import script from "./PosSales.vue?vue&type=script&lang=js"
export * from "./PosSales.vue?vue&type=script&lang=js"

import "./PosSales.vue?vue&type=style&index=0&id=63449928&scoped=true&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=1&lang=css"

import exportComponent from "D:\\xampp7\\htdocs\\24x7pos\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63449928"]])

export default __exports__